import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { TimeSetupService } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-academy-grid",
	templateUrl: "./academy-grid.component.html",
	styleUrls: ["./academy-grid.component.css"],
})
export class AcademyGridComponent implements OnInit {
	constructor(private timeSetupService: TimeSetupService, private confirmationService: ConfirmationService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		if (this.SchoolID != undefined) {
			this.loadAcademyList();
		}
	}

	ngOnChanges() {
		if (this.SchoolID != undefined) {
			this.loadAcademyList();
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SchoolID: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedAcademy: any;
	lstAcademy: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "AcademyDesc", header: "Academy" },
		// { field: 'TardyTime', header: 'Tardy Time' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadAcademyList() {
		this.loading = true;

		var result = this.timeSetupService.TimeSettingsAcademySelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				for (var i = 0; i < this.lstAcademy.length; i++) {
					var next = this.lstAcademy[i];

					//Create Date from Tardy Time string
					if (next.TardyTime != "") {
						next.TardyTimeDate = new Date(String(next.TardyTime));
					} else {
						var Today = new Date();
						Today.setHours(0, 0, 0, 0);
						next.TardyTimeDate = Today;
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onUpdate(val) {
		var fTime = "1900-01-01 " + moment(new Date(val.TardyTimeDate)).format("HH:mm:00");

		var result = this.timeSetupService.TimeSettingsUpdateAcademyTardyTime(val.AcademyID, fTime);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "timeacademy",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Academy Tardy Time was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadAcademyList();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "timeacademy",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Academy's Tardy Time",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onReset(val) {
		//There should only be 1 school for a given school ID
		var next = val;

		if (next.TardyTime != "") {
			next.TardyTimeDate = new Date(String(next.TardyTime));
		} else {
			var Today = new Date();
			Today.setHours(0, 0, 0, 0);
			next.TardyTimeDate = Today;
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedAcademy = val.data;
	}
	onRowUnselect(val) {
		this.SelectedAcademy = null;
	}

	////////////////////////////////////////////
}
